import ApiClient from '../api/apiClient';

const MEMBERSHIPLIST = "/certificates/memberships";
const USERLOGIN = "/user/admin-login"
const MEMBERSHIPSTATUSCOUNT = "/certificates/get-membership-status-count"
const BULKMEMBERSHIPSTATUSUPDATE = "/certificates/multiple-applicants/status"

const getMemberShipList = ({
  page,
  limit,
  search,
  membership_status,
  certificate_type,
  full_name,
  registered_from,
  registered_to,
  start_date,
  end_date,
  field_of_technology,
  technology_field,
  identity_number,
  board_approval_from,
  board_approval_to,
  email,
  filter_status,
  registration_no,
  payment_from,
  payment_to,
}) => {
  const baseUrl = `${MEMBERSHIPLIST}?`;

  let queryParams = "";

  // Add mandatory parameters
  queryParams += `page=${page}&limit=${limit}`;

  const resolvedTechnology =
    field_of_technology != null && field_of_technology !== ""
      ? field_of_technology
      : technology_field;

  // Add optional parameters if present

  if (payment_from) queryParams += `&payment_from=${payment_from}`;
  if (payment_to) queryParams += `&payment_to=${payment_to}`;
  if (registered_from) queryParams += `&registered_from=${registered_from}`;
  if (registered_to) queryParams += `&registered_to=${registered_to}`;
  if (start_date) queryParams += `&start_date=${start_date}`;
  if (end_date) queryParams += `&end_date=${end_date}`;
  if (filter_status) queryParams += `&filter_status=${filter_status}`;
  if (board_approval_from) queryParams += `&board_approval_from=${board_approval_from}`;
  if (email) queryParams += `&email=${email}`;
  if (board_approval_to) queryParams += `&board_approval_to=${board_approval_to}`;
  if (registration_no) queryParams += `&registration_no=${registration_no}`;
  if (certificate_type) queryParams += `&certificate_type=${certificate_type}`;
  if (identity_number) queryParams += `&identity_number=${identity_number}`;
  if (search) queryParams += `&search=${search}`;
  if (resolvedTechnology != null && resolvedTechnology !== "")
    queryParams += `&field_of_technology=${resolvedTechnology}`;
  if (full_name) queryParams += `&full_name=${full_name}`;
  if (membership_status) queryParams += `&membership_status=${membership_status}`;

  const url = baseUrl + queryParams;

  return ApiClient.get(url);
};

const userLogin = (data) => {
  return ApiClient.post(USERLOGIN, data);
}

const getMembershipStatusCount = ({
  search,
  membership_status,
  certificate_type,
  full_name,
  registered_from,
  registered_to,
  start_date,
  end_date,
  field_of_technology,
  technology_field,
  identity_number,
  board_approval_from,
  board_approval_to,
  email,
  filter_status,
  registration_no,
  payment_from,
  payment_to,
}) => {
  const baseUrl = `${MEMBERSHIPSTATUSCOUNT}?`;

  let queryParams = "";

  const resolvedTechnology =
    field_of_technology != null && field_of_technology !== ""
      ? field_of_technology
      : technology_field;

  // Add optional parameters if present

  if (registered_from) queryParams += `&registered_from=${registered_from}`;
  if (registered_to) queryParams += `&registered_to=${registered_to}`;
  if (payment_from) queryParams += `&payment_from=${payment_from}`;
  if (payment_to) queryParams += `&payment_to=${payment_to}`;
  if (email) queryParams += `&email=${email}`;
  if (filter_status) queryParams += `&filter_status=${filter_status}`;
  if (board_approval_from) queryParams += `&board_approval_from=${board_approval_from}`;
  if (board_approval_to) queryParams += `&board_approval_to=${board_approval_to}`;
  if (registration_no) queryParams += `&registration_no=${registration_no}`;
  if (start_date) queryParams += `&start_date=${start_date}`;
  if (end_date) queryParams += `&end_date=${end_date}`;
  if (certificate_type) queryParams += `&certificate_type=${certificate_type}`;
  if (identity_number) queryParams += `&identity_number=${identity_number}`;
  if (search) queryParams += `&search=${search}`;
  if (resolvedTechnology != null && resolvedTechnology !== "")
    queryParams += `&field_of_technology=${resolvedTechnology}`;
  if (full_name) queryParams += `&full_name=${full_name}`;
  if (membership_status) queryParams += `&membership_status=${membership_status}`;

  const url = baseUrl + queryParams;

  return ApiClient.get(url);
}

const updateBulkMembershipStatus = (data) => {
  return ApiClient.put(BULKMEMBERSHIPSTATUSUPDATE, data);
};

export const membershipService = {
  getMemberShipList,
  userLogin,
  getMembershipStatusCount,
  updateBulkMembershipStatus
};